<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>{{ data.text }}</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="close(false)">{{ data.closeText }}</button>
  <button mat-flat-button color="primary" (click)="close(true)">
    {{ data.confirmText }}
  </button>
</div>
